<template>
  <button
    :class="buttonClass"
    @click="send()"
  >
    <img
      src="/img/twitter_icon.svg"
           
      alt=""
    >
    <span v-if="buttonText">{{ buttonText }}</span>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },

  methods: {
    send() {
    var text_tmp = this.text ? "&text=" + this.text : ""

      window.open(
        "https://twitter.com/intent/tweet?url=" +
          this.url +
           text_tmp+
          "&via=folkradiohu",
        "_blank"
      );
    }
  }
};
</script>
